<template>
    <div class="upload-img" :class="{'has-image':!!files.length}">
        
        <div class="images-list" ref="imageList" :key="refreshKey">
            <template v-for="(image,key) in files">
                
                <div :key="key" class="image-container drag-handle"
                     :style="{backgroundImage:`url(${image})`}" :data-id="key" v-if="true">
                    <div class="image-opera">
                        <a-button v-if="!disabled" @click="delImage(key)" type="link">
                            <span class="upload-del"></span>
                        </a-button>
                        <a-button @click="previewImageDetail(key)" type="link">
                            <span class="upload-fd"></span>
                        </a-button>
                    </div>
                </div>
            
            </template>
            
            <template v-if="showUploader && (!(files.length && !multiple )) && ((maxLength -files.length) > 0 )">
                <a-upload
                    name="image"
                    list-type="picture-card"
                    class="avatar-uploader no-drag"
                    :show-upload-list="false"
                    :action="fullAction"
                    :before-upload="beforeUpload"
                    @change="handleChange"
                    :disabled="disabled"
                    data-id="-1"
                >
                    <div>
                        <a-icon class="up-icon" :type="loading ? 'loading' : 'upload'"/>
                    </div>
                </a-upload>
            </template>
        </div>
        
        <image-cropper
            v-if="showCropper"
            v-model="showCropper"
            :image="cropperTargetImg"
            :aspect-ratio="cropRatio"
            :max-width="1500"
            :max-height="1500"
            @cropped="handleCroppedSuccess"
        />
    
    </div>
</template>

<script>
import api from '@/repo/api';
import auth from "../auth";
import Sortable from "sortablejs";
import axios from "axios"; // 【新增】用于手动上传剪裁后的图片
import ImageCropper from "./ImageCropper"; // 【新增】引入你的剪裁组件

export default {
    name: "UploadImage",
    components: { ImageCropper }, // 【新增】注册组件
    model: {
        event: "change",
        prop: "imageUrl"
    },
    props: {
        imageUrl: {
            type: [String, Array]
        },
        disabled: Boolean,
        usage: String,
        multiple: Boolean,
        action: {
            type: String,
            default() {
                return api.colUrl('/image/upload')
            }
        },
        maxLength: {
            type: Number,
            default() {
                return 9;
            }
        },
        done: Function,
        preview: Function,
        
        // 【新增】是否开启剪裁，默认为 false
        enableCrop: {
            type: Boolean,
            default: false
        },
        // 【新增】剪裁比例，默认 1:1
        cropRatio: {
            type: Number,
            default: 1
        }
    },
    watch: {
        action() {
            this.buildFullAction()
        },
        imageUrl: {
            handler() {
                this.initFiles()
            },
            immediate: true,
            deep: true
        }
    },
    data() {
        return {
            loading: false,
            showPreviewModal: false,
            fullAction: '',
            files: [],
            previewImage: '',
            showUploader: true,
            sortable: null,
            refreshKey: 0,
            
            // 【新增】剪裁相关数据
            showCropper: false,    // 控制剪裁弹窗
            cropperTargetImg: '',  // 待剪裁图片的 Base64
            originalFileName: '',  // 暂存原始文件名
        }
    },
    mounted() {
        this.buildFullAction()
    },
    destroyed() {
        if (this.sortable) this.sortable.destroy()
    },
    methods: {
        initSortAble() {
            if (this.sortable) this.sortable.destroy()
            
            this.$nextTick(() => {
                const tbody = this.$refs.imageList;
                // 防止在未渲染时报错
                if (!tbody) return;
                
                this.sortable = Sortable.create(tbody, {
                    handle: '.drag-handle',
                    animation: 150,
                    ghostClass: 'sortable-ghost',
                    chosenClass: 'sortable-chosen',
                    dragClass: 'sortable-drag',
                    filter: 'no-drag',
                    onEnd: () => {
                        const files = JSON.parse(JSON.stringify(this.files))
                        const newFiles = this.sortArray(files, this.sortable.toArray())
                        this.sortedFiles = newFiles
                        this.$emit('change', newFiles)
                    }
                });
            })
        },
        sortArray(oldArray, newOrder) {
            const validIndices = newOrder
                .filter(item => /^\d+$/.test(item))
                .map(Number)
                .filter(index => index >= 0 && index < oldArray.length);
            return validIndices.map(index => oldArray[index]);
        },
        initFiles() {
            if (typeof this.imageUrl === 'string') {
                this.files = this.imageUrl ? [this.imageUrl] : []
            } else {
                this.files = this.imageUrl || []
            }
            
            if (this.multiple) this.initSortAble()
            
            this.refreshKey++
        },
        buildFullAction() {
            let appId = localStorage['mini_app_id'];
            if (this.action.indexOf('?') === -1) {
                this.fullAction = this.action + '?token=' + auth.getToken() + '&_mini_app_id=' + appId + '&usage=' + this.usage
                return;
            }
            this.fullAction = this.action + '&token=' + auth.getToken() + '&_mini_app_id=' + appId + '&usage=' + this.usage
        },
        delImage(idx) {
            if (this.disabled) return;
            
            let url = this.files.splice(idx, 1);
            
            if (this.multiple) {
                this.$emit('change', this.files)
            } else {
                this.$emit('change', this.files[0] || '')
            }
            
            this.$emit('del', url[0])
        },
        previewImageDetail(idx) {
            if (typeof this.preview === 'function') {
                this.preview(this.files[idx])
                return;
            }
            this.$previewImages(this.files, idx)
        },
        
        // ==========================================
        // 【核心修改】上传拦截与处理逻辑
        // ==========================================
        
        /**
         * 上传前钩子：
         * 1. 基础校验
         * 2. 如果开启 enableCrop，则拦截上传，打开剪裁器
         */
        beforeUpload(file) {
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
            if (!isJpgOrPng) {
                this.$message.error('你只能上传jpg,png文件!');
                return false;
            }
            
            const isLt4M = file.size / 1024 / 1024 < 4;
            if (!isLt4M) {
                this.$message.error('图片必须小于4M!');
                return false;
            }
            
            // 【新增逻辑】如果开启剪裁
            if (this.enableCrop) {
                this.originalFileName = file.name; // 记录文件名
                // 使用 FileReader 读取文件为 Base64
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    this.cropperTargetImg = reader.result; // 将 Base64 传给剪裁组件
                    this.showCropper = true; // 打开弹窗
                };
                // 返回 false 阻止 a-upload 的默认自动上传行为
                return false;
            }
            
            // 未开启剪裁，返回 true 继续默认上传
            return true;
        },
        
        /**
         * 【新增】剪裁组件完成剪裁后的回调
         * @param base64Data 剪裁后的 base64 图片数据
         */
        handleCroppedSuccess(base64Data) {
            // 1. 转回 Blob
            const blob = this.dataURLtoBlob(base64Data);
            // 2. 手动上传
            this.uploadCustom(blob, this.originalFileName);
        },
        
        /**
         * 【新增】手动上传 Blob 文件
         */
        uploadCustom(blob, fileName) {
            this.loading = true;
            
            const formData = new FormData();
            // 注意：文件名在第三个参数
            formData.append('image', blob, fileName || 'cropped.png');
            
            // 构造上传参数 (与 buildFullAction 逻辑保持一致)
            // 这里建议直接复用 api 库，如果不行则使用 axios
            const appId = localStorage['mini_app_id'];
            
            axios.post(this.action, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    // 'Authorization': auth.getToken() // 如果需要在header里传token请取消注释
                },
                params: {
                    token: auth.getToken(),
                    _mini_app_id: appId,
                    usage: this.usage
                }
            }).then(res => {
                const response = res.data;
                if (response.code !== 0) {
                    this.$message.error(response.msg);
                    this.loading = false;
                    return;
                }
                // 成功后调用统一处理逻辑
                this.handleUploadSuccess(response.data);
            }).catch(err => {
                console.error(err);
                this.$message.error('上传失败');
                this.loading = false;
            });
        },
        
        /**
         * 【新增】Base64 转 Blob 工具函数
         */
        dataURLtoBlob(dataurl) {
            let arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {type:mime});
        },
        
        /**
         * 【新增】抽取统一的成功回调逻辑
         * 供 manual upload (剪裁后) 和 default upload (直接上传) 使用
         */
        handleUploadSuccess(responseData) {
            let url = '';
            
            if (typeof this.done === 'function') {
                url = this.done(responseData);
            } else {
                url = responseData;
                
                if (!this.multiple) {
                    this.$emit('change', url);
                } else {
                    this.files.push(url);
                    this.$emit('change', this.files);
                }
                
                // 刷新 uploader 状态 (Hack)
                this.showUploader = false;
                setTimeout(() => {
                    this.showUploader = true;
                }, 100);
            }
            
            this.loading = false;
        },
        
        /**
         * 【修改】默认上传的 change 事件
         */
        handleChange(info) {
            if (info.file.status === 'uploading') {
                this.loading = true;
                return;
            }
            if (info.file.status === 'done') {
                let response = info.file.response;
                
                if (response.code !== 0) {
                    this.loading = false;
                    return this.$message.error(response.msg)
                }
                
                // 使用统一的成功处理逻辑
                this.handleUploadSuccess(response.data);
            }
        },
    }
}
</script>

<style lang="less" scoped>
.upload-img {
    line-height: 0;
}

.up-icon {
    font-size: 24px;
}

.avatar-uploader {
    width: 110px;
}

.image-opera {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.4);
    line-height: 0;
}

.image-container {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
    position: relative;
    margin-right: 8px;
    margin-bottom: 8px;
    width: 102px;
    height: 102px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    
    img {
        max-width: 100%;
        max-height: 100%;
    }
}

.upload-del, .upload-fd {
    display: block;
    width: 20px;
    height: 20px;
    background-image: url("/assets/icons/upload-del.png");
    background-size: 20px;
}

.upload-fd {
    background-image: url("/assets/icons/upload-fd.png");
}

.img-modal {
    /deep/ .ant-modal {
        top: 0;
        width: 100vw !important;
        min-height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    
    img {
        max-width: 1000px;
    }
    
}

.images-list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
}

.drag-handle {
    cursor: grab;
    user-select: none;
}
</style>